// @flow

export const validateClass = (clazz, decorator) => {
  if (typeof clazz !== 'function') {
    throw new Error(`@${decorator} decorator can only be applied to class not: ${typeof clazz}`);
  }
};

export const validateFunction = (func, decorator) => {
  if (typeof func !== 'function') {
    throw new Error(`@${decorator} decorator can only be applied to methods not: ${typeof func}`);
  }
};

// Default export attendu par les ré-exports qui utilisent `export ... from`
const validators = {
  validateClass,
  validateFunction,
};

export default validators;

// Compatibilité CommonJS
if (typeof module !== 'undefined' && module.exports) {
  module.exports = validators;
  module.exports.validateClass = validateClass;
  module.exports.validateFunction = validateFunction;
}
